var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useContext, useRef, useState } from "react";
import { useSnackbar } from "../Snackbar";
import { EditContext } from "./EditProvider";
import { EventEmitter } from "nate-react-api-helpers";
const lighthouseEmitter = new EventEmitter();
let lighthouseCounter = 0;
document.body.addEventListener("dragenter", e => { if (lighthouseCounter === 0) {
    if (lighthouseEmitter.lastValue === true)
        return;
    lighthouseEmitter.emit(true);
} lighthouseCounter++; });
document.body.addEventListener("dragleave", e => { if (lighthouseCounter > 0)
    lighthouseCounter--; if (lighthouseCounter === 0) {
    if (lighthouseEmitter.lastValue === false)
        return;
    lighthouseEmitter.emit(false);
} });
document.body.addEventListener("drop", e => { lighthouseCounter = 0; lighthouseEmitter.emit(false); });
export function useDragDrop(props) { var _column$editable; const column = props.column; const hasDragOver = !!((_column$editable = column.editable) !== null && _column$editable !== void 0 && _column$editable.fileDropAction); const [dragOver, setDragOver] = useState(false); const snack = useSnackbar(); const { update } = useContext(EditContext); const enterCountRef = useRef(0); const lighthouse = EventEmitter.reactValue(lighthouseEmitter); return { isDraggingOver: dragOver, isLighthouse: hasDragOver && lighthouse, hasDragOver: hasDragOver, onDragOver: orBlank(hasDragOver, d => { d.preventDefault(); }), onDragEnter: orBlank(hasDragOver, d => { d.preventDefault(); if (enterCountRef.current === 0)
        setDragOver(true); enterCountRef.current++; }), onDragLeave: orBlank(hasDragOver, d => { d.preventDefault(); if (enterCountRef.current > 0)
        enterCountRef.current--; if (enterCountRef.current === 0)
        setDragOver(false); }), onDrop: orBlank(hasDragOver, (d) => __awaiter(this, void 0, void 0, function* () { var _column$editable2, _column$editable3; if (!((_column$editable2 = column.editable) !== null && _column$editable2 !== void 0 && _column$editable2.fileDropAction))
        return; const uploadAction = column.editable.fileDropAction; d.preventDefault(); enterCountRef.current = 0; setDragOver(false); const files = d.dataTransfer.files; const accept = ((_column$editable3 = column.editable) === null || _column$editable3 === void 0 ? void 0 : _column$editable3.fileDropAccept) || []; let list = Array.from(files); if (accept.length > 0) {
        list = list.filter(f => { return !!accept.find(a => mimeMatches(a, f.type)); });
    } if (list.length === 0)
        return; snack.loading("Uploading..."); try {
        yield uploadAction(list, { row: props.value, update: update });
        snack.hide();
    }
    catch (e) {
        snack.error(e.toString());
    } })) }; }
function orBlank(tf, callback) { if (tf)
    return callback; return undefined; }
function mimeMatches(pattern, value) { if (pattern === "*/*") {
    return true;
} if (pattern.endsWith("/*")) {
    return value.startsWith(pattern.replace(/\/\*$/, ""));
} return pattern === value; }
